const valuePropsSlider = () => {
  const swiper = new Swiper('.vph_container .swiper',{
    slidesPerView: 'auto',
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 0,
    },
    breakpoints:{
      320:{
       spaceBetween: 72,
      },
    }
  })
}

export default valuePropsSlider;